module.exports = __webpack_public_path__ + "media/intro_with_long_soprano.b334faa3.mp3";